import React from 'react'
import { useTiaUI } from '../../index'
import { Box } from '../../re-exports'
import { getCSS } from '../../util'

export type WaveProps = {
    fill: string
    sx?: object
    position?: 'top' | 'bottom' | 'right' | 'left'
    waveLength?: number
    waveAmplitude?: string[]
}

/**
 * Wave
 * Generated with https://www.shapedivider.app/
 * Parent element must have position: 'relative'
 */
export const Wave = ({
    fill,
    sx,
    position = 'bottom',
    waveLength = 134,
    waveAmplitude = ['15px', '43px']
}: WaveProps) => {
    const { theme } = useTiaUI()
    const isVertical = position === 'left' || position === 'right'
    const waveLengthStr = `calc(${waveLength}% + 1.3px)`
    const fillColor = getCSS(theme)('color', fill)
    let additionalProps, viewbox

    // left or right
    if (isVertical) {
        additionalProps = {
            [position]: 0,
            'top': 0,
            'height': '100%',
            'width': waveAmplitude,
            '& > svg': {
                height: waveLengthStr,
                width: waveAmplitude
            },
            '& > svg > path': {
                transform: 'scale(-1,1) rotate(90deg)'
            }
        }
        viewbox = '0 0 120 1200'
    } else {
        additionalProps = {
            [position]: 0,
            'left': 0,
            'width': '100%',
            '& > svg': {
                width: waveLengthStr,
                height: waveAmplitude
            }
        }
        viewbox = '0 0 1200 120'
    }

    return (
        <Box
            sx={{
                position: 'absolute',
                overflow: 'hidden',
                lineHeight: 0,
                ...additionalProps,
                ...sx
            }}
        >
            <svg
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={viewbox}
                preserveAspectRatio="none"
            >
                <path
                    d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                    fill={fillColor}
                ></path>
            </svg>
        </Box>
    )
}
